import React from "react";
import styled from "styled-components";

import { Checkbox } from "@material-ui/core";
import { IStringTMap } from "../../interfaces";
import Text from "../atoms/Text";
import List from "../molecules/List";
import { IFilterState } from "../pages/TalkListPage";

interface IProps {
  options: IFilterState[];
  setFilterOptions: React.Dispatch<React.SetStateAction<IFilterState[]>>;
}

const FilterOptions: React.FC<IProps> = ({ options, setFilterOptions }) => {
  const optionNameMap: IStringTMap<string> = {
    unfinished: "未対応",
    finished: "対応済み"
  };

  const selectFilterOption = (targetOption: IFilterState): void => {
    const newState: IFilterState[] = [];

    for (const option of options) {
      if (option.key === targetOption.key) {
        option.checked = true;
        newState.push(option);
        continue;
      }
      newState.push(option);
    }

    setFilterOptions(newState);
  };

  const deselectFilterOption = (targetOption: IFilterState): void => {
    const newState: IFilterState[] = [];

    for (const option of options) {
      if (option.key === targetOption.key) {
        option.checked = false;
        newState.push(option);
        continue;
      }
      newState.push(option);
    }

    setFilterOptions(newState);
  };
  return (
    <FilterOptionList
      items={options.map((option, i) => {
        return (
          <FilterOptionAlign>
            <Text>{optionNameMap[option.key]}</Text>
            <Checkbox
              checked={option.checked}
              onChange={e => {
                option.checked
                  ? deselectFilterOption(option)
                  : selectFilterOption(option);
              }}
            />
          </FilterOptionAlign>
        );
      })}
    />
  );
};

export default FilterOptions;

const FilterOptionAlign = styled.div``;
const FilterOptionList = styled(List)`
  > li {
    > div {
      display: flex;
      justify-content: space-between;
    }
  }
`;
